import moduleCollapsible from '../../modules/module--collapsible';

function setup($el) {
    $el.append($(`<ul class="menu-topics__list"></ul>`));
}

function makeMenu({ elToggleRemote, module, $el, title, id, controls }) {
    // Make Menu Items
    const listItem = $(
        `<li class='menu-topics__item'><button class="${elToggleRemote.substring(
            1
        )}" type="button" data-collapsible-remote-target="${id}">${title}</button></li>`
    );
    $('.menu-topics__list').append(listItem);
    // Make anchor scroll links
    const link = $(`<a href="#${id}" class="slow-scroll hide-v">${title}</a>`);
    listItem.append(link);
}

function setupExpandCollapseAll($target, getInstance, elToggle) {
    const $expand = $('<button type="button" class="k-button">Expand All</button>');
    const $collapse = $('<button type="button" class="k-button">Collapse All</button>');

    $expand.on('click', () => $(elToggle).each((_, el) => getInstance().open($(el))));
    $collapse.on('click', () => $(elToggle).each((_, el) => getInstance().close($(el))));

    $target.append($expand).append($collapse);
}

function toggleClick(el) {
    $(el).on('click', function(e) {
        const $remoteToggle = $(e.target);
        const $currentToggle = $(`#${$remoteToggle.attr('data-collapsible-remote-target')}`);
        $currentToggle.triggerHandler('click');
        $(document).on('on:CollapsibleToggleRemoteSlideDown', function() {
            $remoteToggle.next().triggerHandler('click');
        });
    });
}

export default function($element) {
    const closeOthers = $element.data('closeOthers') !== false;
    const expandCollapseTarget = $element.data('expandCollapseTarget');
    let instance;

    instance = moduleCollapsible.add({
        block: '.collapsible--remote',
        elToggle: '.collapsible__toggle--remote',
        elToggleRemote: '.menu-topics__toggle',
        elContent: '.collapsible__content--remote',
        closeOutside: false,
        closeAny: false,
        closeOthers: closeOthers,
        speed: 250,
        debug: false,
        callbackBuilt({ elToggle, elToggleRemote }) {
            return function cb() {
                setup($element);

                $(elToggle).each(function(i, el) {
                    const $elToggle = $(el);
                    makeMenu({
                        elToggleRemote,
                        $el: $elToggle,
                        title: $elToggle.attr('data-collapsible-remote-title'),
                        id: $elToggle.attr('id'),
                        controls: $elToggle.attr('aria-controls'),
                        initialState: $elToggle.attr('data-cc-state')
                    });
                });

                toggleClick(elToggleRemote);

                if (expandCollapseTarget) {
                    setupExpandCollapseAll($(expandCollapseTarget), () => instance, elToggle);
                }
            };
        },
        callbackOpenAfter({ elToggleRemote }, { $activeToggle }) {
            $(elToggleRemote).each(function(i, el) {
                const currentId = $($activeToggle[i]).attr('id') || false;
                $(`[data-collapsible-remote-target=${currentId}]`).attr({
                    'data-cc-state': 'open'
                });
            });
        },
        callbackCloseAfter({ elToggleRemote }, { $activeToggle }) {
            $(elToggleRemote).each(function(i, el) {
                const currentId = $($activeToggle[i]).attr('id') || false;
                $(`[data-collapsible-remote-target=${currentId}]`).attr({
                    'data-cc-state': 'closed'
                });
            });
        }
    });
}
